import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Product, Variant } from 'src/app/shop';
import { AddCartLine } from 'src/app/shop/models/cart.model';
import { OrderLineItem } from 'src/app/shop/models/order.model';

@Component({
    selector: 'app-order-product-list-item',
    templateUrl: './order-product-list-item.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class OrderProductListItemComponent implements OnInit {
  @Input() line!: OrderLineItem;
  @Input() type: 'display' | 'edit' = 'display';
  @Input() variant?: Variant | undefined;

  @Output() newLine = new EventEmitter<AddCartLine>();

  amount = 0;

  constructor(private cd: ChangeDetectorRef) {}

  ngOnInit(): void {
    // console.log(this.line);
    this.amountUpdate(this.maxAvailable > -1 ? this.line.currentQuantity : 0);
  }

  amountUpdate(e: number) {
    this.amount = e;
    this.newLine.emit({ quantity: this.amount, merchandiseId: this.line?.variant?.id });
    this.cd.detectChanges();
  }

  get maxAvailable(): number {
    // check with variant options
    if (!this.variant || !this.variant?.availableForSale) {
      return -1;
    }
    if (this.variant?.availableForSale && this.variant?.quantityAvailable <= 0) {
      return 0;
    }
    return this.variant?.quantityAvailable;
  }
}
